import styled, { css } from 'styled-components';
import { red, blue, green, yellow, fadein, alertAppearance } from './AlertConstants';
import { LinkButton } from '../Button';

const border = props => {
  switch (props.appearance as alertAppearance) {
    case 'danger':
      return `
        border: 2px solid ${red};
      `;
    case 'info':
      return `
        border: 2px solid ${blue};
      `;
    case 'success':
      return `
        border: 2px solid ${green};
      `;
    case 'warning':
      return `
        border: 2px solid ${yellow};
      `;
    default:
      return '';
  }
};

const appearanceSpecific = props => {
  switch (props.appearance as alertAppearance) {
    case 'danger':
      return css`
        background: ${red};

        &::before {
          content: '\f05e';
        }
      `;
    case 'info':
      return css`
        background: ${blue};

        &::before {
          content: '\f12a';
        }
      `;
    case 'success':
      return css`
        background: ${green};

        &::before {
          content: '\f00c';
        }
      `;
    case 'warning':
      return css`
        background: ${yellow};

        &::before {
          content: '\f071';
          color: #444;
        }
      `;
    default:
      return '';
  }
};

export const StyledAlert = styled.div<{ appearance: alertAppearance }>`
  ${border};
  width: auto;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: row;
  background: #fff;
  margin: 24px 0;

  animation: ${fadein} 1s;
`;

export const AlertIcon = styled.div<{ appearance: alertAppearance }>`
  width: 54px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  &:before {
    font-family: 'Font Awesome 5 Pro';
    position: absolute;
    top: 50%;
    left: 0;
    margin: auto;
    color: #fff;
    width: 100%;
    text-align: center;
    font-size: 1.5em;
    font-weight: 900;
    transform: translateY(-50%);
  }

  ${appearanceSpecific}
`;

export const AlertTextContainer = styled.ul`
  display: inline-block;
  margin: 0 0 0 54px;
  padding: 8px 16px;
  color: #4a4d4f;
  list-style-type: none;
`;

export const AlertMessageItem = styled.li`
  display: list-item;
  box-sizing: border-box;

  & + & {
    padding-top: 5px;
  }
`;

export const AlertClose = styled(LinkButton)`
  position: absolute;
  top: 4px;
  right: 5px;
  font-size: 12px;
  color: #6c727f;
`;
